<template>
  <div>
    <section-title class="mt-2" content="Campos" :has-line="true" />
    <div class="row ml-1">
      <error
        v-if="error"
        variant="no-border"
        message="Debe seleccionar al menos 3 columnas."
      />
    </div>
    <div class="rounded bg-light-gray pt-2 p-3">
      <div class="row mb-3">
        <div v-if="isMobile" class="w-100 mb-3">
          <button
            ref="ddlCompactMenu"
            class="btn px-4 btn-dropdown-actions"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :class="setShowDropdown && 'active'"
            @click="setShowDropdown"
          >
            <div class="btn-dropdown-items dropdown-toggle">
              <span class="btn-dropdown-title">Seleccione datos</span>
            </div>
          </button>
          <div
            v-if="showDropdown"
            class="list-group mt-3"
            id="list-tab"
            role="tablist"
          >
            <a
              class="d-flex align-items-center list-group-item list-group-item-action mb-3 rounded font-weight-bold"
              id="list-profile-list"
              data-toggle="list"
              href="#list-profile"
              role="tab"
              aria-controls="profile"
              v-for="item in subTopics"
              :key="item.id"
              @click="getColumns(item)"
              :class="topicClass(item)"
            >
              <span>{{ item.name }}</span>
              <span class="ml-2">
                {{ topicCounter(item.id) }}
              </span>
            </a>
            <custom-result-not-found v-if="subTopics.length == 0" />
          </div>
        </div>
        <div v-else class="col-12 col-md-3 mb-3 mb-md-0">
          <p class="font-14 font-weight-normal">Seleccione datos:</p>
          <div class="list-group" id="list-tab" role="tablist">
            <a
              class="d-flex align-items-center list-group-item list-group-item-action mb-3 rounded font-weight-bold"
              id="list-profile-list"
              data-toggle="list"
              href="#list-profile"
              role="tab"
              aria-controls="profile"
              v-for="item in subTopics"
              :key="item.id"
              @click="getColumns(item)"
              :class="topicClass(item)"
            >
              <span>{{ item.name }}</span>
              <span class="ml-2">
                {{ topicCounter(item.id) }}
              </span>
            </a>
            <custom-result-not-found v-if="subTopics.length == 0" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <p class="font-14 font-weight-normal">
            Seleccione las columnas disponibles:
          </p>
          <input
            type="search"
            class="form-control"
            placeholder="Búsqueda"
            v-model="searchText"
          />
          <div
            class="rounded bg-white border mt-3 p-4 overflow-auto max-height-100"
          >
            <custom-result-not-found v-if="options.length == 0" />
            <div v-else v-for="(column, idx) in options" :key="column.id">
              <div>
                <check-box
                  ref="items"
                  :data-required="column.required"
                  :data-id="column.id"
                  :data-subTopicId="column.subTopicId"
                  class="font-16 font-weight-normal"
                  :text="column.name"
                  v-model="column.selected"
                  :disabled="modeReadOnly && !copyMode"
                  @input="(e) => handleChecked(e, column, idx)"
                />
                <p class="font-14 font-weight-normal text-muted ml-4 pl-1">
                  {{ column.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mt-3 mt-md-0">
          <div class="d-flex justify-content-between">
            <p class="font-14 font-weight-normal">Columnas seleccionadas:</p>
            <span
              class="badge badge-pill badge-primary d-flex justify-content-center align-items-center badge-counter"
              :class="
                modeReadOnly && !copyMode
                  ? 'bg-gray-light text-muted font-weight-normal'
                  : 'bg-orange'
              "
            >
              {{ columnsChecked.length }} / {{ limit }}
            </span>
          </div>
          <div v-if="!modeReadOnly || copyMode" class="columns-checked-wrapper">
            <draggable
              ghost-class="ghost"
              v-model="columnsChecked"
              group="people"
              :scroll-sensitivity="200"
              force-fallback
              @start="drag = true"
              @end="drag = false"
            >
              <div
                class="d-flex justify-content-between list-group-item mb-3 rounded font-weight-bold pointer"
                v-for="element in columnsChecked"
                :key="element.id + element.subTopicId"
              >
                <div>
                  <i class="fas fa-bars text-ligh-gray mr-3"></i>
                  <span>{{ element.name }} {{ subTopicName(element) }}</span>
                </div>
                <i
                  class="fas fa-times text-ligh-gray mt-1 cursor-pointer"
                  @click="removeAt(element)"
                ></i>
              </div>
            </draggable>
          </div>
          <div v-else class="columns-checked-wrapper">
            <div
              class="d-flex justify-content-between list-group-item mb-3 rounded font-weight-bold not-allowed"
              v-for="element in columnsChecked"
              :key="element.id"
            >
              <div>
                <i class="fas fa-bars text-ligh-gray mr-3"></i>
                <span>{{ element.name }} {{ subTopicName(element) }}</span>
              </div>
              <i class="fas fa-times text-ligh-gray mt-1 not-allowed"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle'
import CheckBox from 'CheckBox'
import CustomResultNotFound from 'custom-result-not-found'
import Error from '@/components/common/Error'
import draggable from 'vuedraggable'
import SpecialService from '@/services/api/special.api'

export default {
  name: 'Fields',
  components: {
    SectionTitle,
    CheckBox,
    CustomResultNotFound,
    Error,
    draggable,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    error: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    onPreview: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    copyMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    subTopics: [],
    commonSubtopicNavs: [],
    unCommonSubtopicNavs: [],
    searchText: '',
    columns: [],
    columnsChecked: [],
    subTopicSelected: null,
    limit: 0,
    oldTopic: 0,
    showDropdown: false,
  }),
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    options() {
      const list = this.columns ? this.columns : []
      let items = this.searchText
        ? list.filter((e) =>
            e.name.toLowerCase().match(this.searchText.toLowerCase())
          )
        : list

      if (
        this.model.id === 0 ||
        this.model.id == undefined ||
        this.model.id == null
      ) {
        items = items?.filter((e) => e.subTopicId === this.subTopicSelected)
      }
      return items
    },
    numberOfColumnsSelected() {
      return (subTopicId) => {
        return this.columnsChecked?.filter(
          (e) => e.subTopicId === subTopicId && e.selected
        ).length
      }
    },
    topicCounter() {
      return (subTopicId) => {
        const count = this.numberOfColumnsSelected(subTopicId)
        return count > 0 ? `(${count})` : ''
      }
    },
    topicClass() {
      return (subTopic) => {
        const count = this.numberOfColumnsSelected(subTopic.id)

        if (subTopic.selected) {
          return 'subtopicSelected'
        }
        if (count > 0) {
          return 'topicHasColumns'
        }

        if (!this.disabledByPacman(subTopic)) {
          return 'topicHasColumnsDisabled'
        }

        return ''
      }
    },
    modeReadOnly() {
      return this.readOnly || this.onPreview
    },
    subTopicName() {
      return (item) => {
        const name = this.subTopics.find((t) => t.id === item.subTopicId)?.name
        const counter = this.columnsChecked.filter(
          (c) => c.id === item.id
        ).length
        if (counter > 1) return `(${name})`

        return null
      }
    },
  },
  watch: {
    'value.topic'(newValue) {
      if (this.oldTopic != newValue) {
        if (
          !this.modeReadOnly &&
          (this.model.id === 0 ||
            this.model.id == undefined ||
            this.model.id == null)
        ) {
          this.clear()
        }
        const id = typeof newValue === 'object' ? newValue.id : newValue
        this.getSubTopics(id)
      }
      this.oldTopic = newValue
    },
    columnsChecked(values) {
      if (!this.copyMode) this.value.columns = [...values]
    },
    readOnly() {
      this.setReadOnly()
    },
    'value.columns'(newValue) {
      if (this.copyMode) this.columnsChecked = [...newValue]
    },
  },
  mounted() {
    this.getLimit()
  },
  methods: {
    async getLimit() {
      const { data } = await SpecialService.getLimit()
      if (data) {
        this.limit = data
      }
    },
    async setShowDropdown() {
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) this.$refs.ddlCompactMenu.ariaExpanded = true
      else this.$refs.ddlCompactMenu.ariaExpanded = false
    },
    async getSubTopics(topicId) {
      const { data } = await SpecialService.getSubTopics(topicId)
      this.subTopics = data.sort((a, b) => a.name - b.name)

      this.subTopics.map(async (subTopic) => {
        //To find the itemSubtopicInfo

        var item = this.columnsChecked.filter(
          (e) => e.selected == true && e.tableId == subTopic.id
        )[0]
        if (item != undefined && item != null) {
          this.pacman(true, item)
          await this.getColumns(subTopic)
        }
      })
    },
    async getColumns(subTopic) {
      if (this.disabledByPacman(subTopic)) {
        this.subTopicSelected = subTopic.id
        subTopic.selected = true

        const { data } = await SpecialService.getColumns(subTopic.id)

        data.forEach(async (e) => {
          const item = this.columnsChecked.find(
            (x) => x.id == e.id && x.subTopicId === e.subTopicId
          )
          if (item) {
            e.selected = item.selected
          }
        })

        this.columns = data

        this.subTopics
          .filter((e) => e.id !== subTopic.id)
          .forEach((e) => (e.selected = false))
      }
    },
    intersection(a1, a2) {
      const isInA2 = (value) => a2.includes(value)
      return a1.filter(isInA2)
    },
    unique(l1, l2, uniqueArr) {
      var a1 = JSON.parse(JSON.stringify(l1))
      var a2 = JSON.parse(JSON.stringify(l2))

      for (var i = 0; i < l1.length; i++) {
        var flag = 0
        for (var j = 0; j < a2.length; j++) {
          if (a1[i] === a2[j]) {
            a2.splice(j, 1)
            j--
            flag = 1
          }
        }
        if (flag == 0) {
          uniqueArr.push(a1[i])
        }
      }

      uniqueArr.push(a2)

      return uniqueArr
    },
    navigations(subTopicId) {
      return this.subTopics.filter(function (x) {
        return x.id === subTopicId
      })[0]?.navigations
    },
    disabledByPacman(subTopic) {
      var availableSutopics = this.commonSubtopicNavs.flat()

      return (
        availableSutopics.includes(subTopic.id) ||
        availableSutopics == undefined ||
        (availableSutopics.length == 0 &&
          this.navigations(subTopic.id).length !== 0)
      )
    },
    pacman(callByEditMode, item) {
      var mapSubtopicIds = []
      var subtopicNavigations = this.navigations(item.subTopicId)

      var colCheckedBySubtopic = this.columnsChecked?.filter(
        (e) => e?.tableId === item?.tableId
      ).length

      //Validate if this have navigation props
      if (subtopicNavigations != undefined && subtopicNavigations.length > 0) {
        mapSubtopicIds = subtopicNavigations.map((e) => {
          return e.value
        })

        if (
          colCheckedBySubtopic === 1 ||
          colCheckedBySubtopic === 0 ||
          callByEditMode
        ) {
          if (
            this.commonSubtopicNavs == undefined ||
            this.commonSubtopicNavs.length === 0
          ) {
            this.commonSubtopicNavs = mapSubtopicIds
          } else {
            var uniqueArr = []

            var commonSubtopicTableIds = this.unique(
              this.commonSubtopicNavs,
              mapSubtopicIds,
              uniqueArr
            ).flat()

            if (
              commonSubtopicTableIds != undefined &&
              commonSubtopicTableIds.length > 0
            ) {
              this.unCommonSubtopicNavs = [
                ...new Set(
                  this.unCommonSubtopicNavs
                    .concat(commonSubtopicTableIds)
                    .map((i) => i)
                ),
              ]
            }

            this.commonSubtopicNavs = this.intersection(
              this.commonSubtopicNavs,
              mapSubtopicIds
            )

            if (colCheckedBySubtopic === 0 && this.columnsChecked.length > 0) {
              var reset = this.unique(
                mapSubtopicIds,
                this.unCommonSubtopicNavs,
                uniqueArr
              ).flat()

              if (commonSubtopicTableIds.length == 0) {
                this.commonSubtopicNavs = reset
                this.unCommonSubtopicNavs = []
              }
            } else if (this.columnsChecked.length == 0) {
              this.unCommonSubtopicNavs = []
              this.commonSubtopicNavs = []
            }
          }
        }
      }
    },
    handleChecked(value, item, index) {
      if (value) {
        if (this.validateLimit(this.columnsChecked.length, item, index)) {
          return
        }

        const element = this.columns.find(
          (e) => e.id === item.id && e.subTopicId === item.subTopicId
        )

        if (this.editMode) {
          element['editMode'] = true
        }

        const exist = this.columnsChecked.find(
          (e) => e.id === item.id && e.subTopicId === item.subTopicId
        )

        if (!exist) {
          this.columnsChecked.push(element)
          if (this.copyMode) {
            this.value.columns.push(element)
          }
          this.autoCheckRequired(index)
        }
      } else {
        const idx = this.columnsChecked.findIndex(
          (e) => e.id === item.id && e.subTopicId === item.subTopicId
        )

        if (idx > -1) {
          this.columnsChecked.splice(idx, 1)
          this.value.columns = [...this.columnsChecked]
        }

        if (
          this.columns.filter((e) => e.selected && !e.required).length === 0
        ) {
          this.autoUnCheckRequired(index)
        }
      }
      this.pacman(false, item)
    },
    removeAt(item) {
      const element = this.columns.find(
        (e) => e.id === item.id && e.subTopicId === item.subTopicId
      )

      if (element) element.selected = false

      const idx = element
        ? this.columnsChecked.findIndex(
            (e) => e.id === element.id && e.subTopicId === element.subTopicId
          )
        : this.columnsChecked.findIndex(
            (e) => e.id === item.id && e.subTopicId === item.subTopicId
          )
      if (idx > -1) this.columnsChecked.splice(idx, 1)
    },
    clear() {
      this.columns = []
      this.columnsChecked = []
      this.value.columns = []
      this.commonSubtopicNavs = []
      this.unCommonSubtopicNavs = []
    },
    setReadOnly() {
      this.columnsChecked = [...this.value.columns]
    },
    autoCheckRequired() {
      for (let index = 0; index < this.$refs.items.length; index++) {
        const element = this.$refs.items[index]
        if (element.$attrs['data-required']) {
          const id = element.$attrs['data-id']
          const subTopicId = element.$attrs['data-subTopicId']
          const column = this.options.find(
            (e) => e.id === id && e.subTopicId === subTopicId
          )

          const exist = this.model.filters.find(
            (e) =>
              (e.id === column.id && e.subTopicId === subTopicId) ||
              e.name.toLowerCase() === column.name.toLowerCase()
          )

          if (!exist) {
            this.model.filters.push({
              ...column,
              model: {
                conditional: null,
                value: null,
              },
            })
          }
        }
      }
    },
    autoUnCheckRequired(index) {
      const current = this.$refs.items[index]
      const subTopicId = current.$attrs['data-subTopicId']
      for (let index = 0; index < this.$refs.items.length; index++) {
        const element = this.$refs.items[index]
        if (element.$attrs['data-required']) {
          this.model.filters = this.model.filters.filter(
            (e) => e.subTopicId !== subTopicId
          )
        }
      }
    },
    validateLimit(columnLength, item, index) {
      if (columnLength >= this.limit) {
        this.$refs.items[index].model = false
        this.$refs.items[index].$el.childNodes[0].checked = false
        item.selected = false
        this.ShowToast(
          'Alerta',
          'Ha alcanzado el límite de selección de columnas.',
          'warning'
        )
        return true
      }

      return false
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/v2/brand_variables.scss';

.columns-checked-wrapper {
  height: 532px;
  overflow-y: scroll;
}

.btn-dropdown-actions {
  border-radius: 6px;
  border: 1px solid #3f5b60;
  height: 3rem;
  background: #3f5b60;
  width: 100%;
}

.btn-dropdown-items {
  display: flex;
  flex-direction: row;
}

.btn-dropdown-actions .btn-dropdown-items .btn-dropdown-title {
  color: #fff;
  font-size: 17px;
  font-weight: 400;
  width: 100%;
  text-align: start;
}

.dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f105';
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  margin-right: 5px;
  border-top: none;
}

.btn-dropdown-actions[aria-expanded='true'] .dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f078';
  font-size: 20px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  margin-right: 5px;
  border-top: none;
}

.bg-gray-light {
  background-color: #e2e2e2;
}

#list-profile-list {
  height: 40px !important;
}

.badge-counter {
  width: 73px;
  height: 27px;
}

.text-ligh-gray {
  color: $secondary-5;
}

.subtopicSelected {
  z-index: 2;
  color: #fff;
  background-color: #ff7058;
  border-color: #ff7058;
}

.topicHasColumns {
  background-color: #b5c3bc;
  border-color: #b5c3bc;
  color: #000;
}

.topicHasColumnsDisabled {
  background-color: #e2e2e2;
  border-color: #e2e2e2;
  color: #000;
}

input[type='search'] {
  padding-left: 52px;
  background: url('../../../assets/img/search-bar.svg') no-repeat left;
  background-color: #fff;
  backdrop-filter: blur(10px);
  background-size: 20px;
  background-position-x: 23px;
  height: 40px !important;

  &::placeholder {
    color: #e2e2e2;
  }
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: #ff6f52 !important;
}

::v-deep input[type='checkbox']:checked + label span em {
  filter: brightness(0) invert(1);
}

::v-deep input[type='checkbox']:disabled + label span em {
  filter: invert(75%) sepia(10%) saturate(13%) hue-rotate(19deg) brightness(88%)
    contrast(84%);
}

::v-deep input[type='checkbox']:disabled + label span {
  background-color: #fff !important;
}

::v-deep input[type='checkbox']:checked:disabled + label span {
  background-color: #e2e2e2 !important;
}

.max-height-100 {
  max-height: 477px !important;
  min-height: 477px !important;
}

.pointer {
  cursor: pointer;
}

.not-allowed {
  cursor: not-allowed;
}

.ghost {
  opacity: 0.5;
  background: $orange;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  border-radius: 4px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
  border-radius: 10px;
  height: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e2e2e2;
  border-radius: 4px;
  height: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e2e2e2;
  border-radius: 4px;
  height: 5px;
}

::-webkit-scrollbar-button {
  height: 5px !important;
}
</style>
